import React, { FunctionComponent, useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend,  Label } from 'recharts';
import moment from 'moment';
import '../../stations/Station.scss';
import { useStoreContext } from '../../../../../store/context';
import { ONEDAY, getMaxFromSelectedFields, getMinFromSelectedFields } from 'src/store/common';

type PrecipOrSRHourlyProps = {
    all_dates: any[],  
}
const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
  const { x, y, payload, timezoneOffset } = props;

  return (
    <g transform={`translate(${x},${y})`} >
      <text
        fontSize=".75rem"
        x={0}
        y={2}
        dy={7}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
      >
        {moment(payload.value).utc().utcOffset(timezoneOffset).format('MMM DD')}
      </text>
    </g>
  );
};
const CustomTooltip:any = (props:any) => {
  const {active, label,payload, timezoneOffset}=props;

  if (active && payload && payload.length) {
    return (
      <div id="custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block', margin:'3px', padding: '3px', height: '3.25rem'}}>
        <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
        {moment(label).utc().utcOffset(timezoneOffset).format("MMM DD, YYYY")}
        </span>
        <span className="hours" style={{fontSize:'.75rem', paddingTop: '0px', paddingBottom: '0px', display:'block'}}>
        {moment(label).utc().utcOffset(timezoneOffset).format("HH:mm")}
        </span>
        <svg width="50" height="10" style={{display: 'block', paddingTop: '0px', paddingBottom: '0px'}}>
          <rect width="5" height="5" style={{fill:'green'}}/>
          <text
            fontSize=".75rem"
            height="5"
            x={10}
            y={10}
          >
          {payload[0] && payload[0].value?`${payload[0].value}`:'0'}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};
export const PrecipOrSRHourly: React.FC<PrecipOrSRHourlyProps> = ({
  all_dates
}) => {
  const [ state ] = useStoreContext();
  const [xTicks, setXTicks] = useState<number[]>([]);
  useEffect(()=>{
    if(all_dates.length>1){
      let ticks:number[]=[];

      if(ticks.length<1){
        let i = moment(all_dates[0].date).set('hour', 13).utc().utcOffset(all_dates[0].offset).format('MMM DD');
        ticks.push(moment(all_dates[0].date).set('hour', 13).utc().utcOffset(all_dates[0].offset).valueOf())
        let j=0;
        while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
          j=j+1;
          ticks.push(moment(all_dates[0].date - j*ONEDAY).set('hour', 13).utc().utcOffset(all_dates[0].offset).valueOf())
          i = moment(all_dates[0].date - j*ONEDAY).set('hour', 13).utc().utcOffset(all_dates[0].offset).format('MMM DD');
        }
        setXTicks(ticks)
      }
  
    }
  },[all_dates]);

  return(
    <>
    {all_dates.length>1 &&(
        <LineChart
          width={450}
          height={140}
          data={all_dates}
          margin={{
            top: (10),
            right: 5,
            left: 5,
            bottom: 10,
          }}
        >
          <XAxis dataKey="date" tick={<CustomizedAxisTick timezoneOffset={all_dates[0].offset}/>} interval={0} type="number" domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" orientation="left" 
            domain={[getMinFromSelectedFields(all_dates, ['valObs', 'valF'],3), getMaxFromSelectedFields(all_dates, ['valObs', 'valF'])]}
            style={{fontSize: '0.7rem',fontFamily: 'serif'}}          
            axisLine={false}>
          <Label
            value={state.chartTable.value ==='Hourly_Precipitation'? 'Precipitation IN': 'Solar Radiation'}
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle',  }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip timezoneOffset={all_dates[0].offset} />} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'11px', top:'130px'}} iconType="plainline" iconSize={10}/>
          <Line name={state.chartTable.value ==='Hourly_Precipitation'? 'Precipitation': 'Solar Radiation'} type="monotone" yAxisId ="left" dataKey="valObs" stroke="green" dot={ false} strokeWidth={2}/>
          <Line name={state.chartTable.value ==='Hourly_Precipitation'? 'Precipitation Forecast': 'Solar Radiation Forecast'}  type="monotone" yAxisId = "left" dataKey="valF" stroke="green" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </LineChart>
    )}
    </>

  );
}